




































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ActionSheet } from 'vant';
import RegisterForm from '@/components/RegisterForm.vue';
import { getUrlParam, skipToMp } from '@/utils/common';
import { ACTIVITY_SKIP_TYPE, ACTIVITY_LINK_TYPE, ACTIVITY_STATUS } from '@/utils/constant';
import merchantApi from '@/api/merchant';
import { ActivityInfoObj, ImageSkipInfo } from '@/interface/merchant';
import { ServerResponse } from '@/interface/common';

@Component({
  name: 'CommonActivity',
  components: {
    [ActionSheet.name]: ActionSheet,
    RegisterForm
  }
})

export default class CommonActivity extends Vue {
  invitationCode = '';
  showRegisterBox = false;
  activityStatus = ACTIVITY_STATUS;
  isBaidu = false;
  clickid = ''; // 抖音数据回传的clickid
  activeInfo: ActivityInfoObj = {
    id: '',
    link: '',
    linkType: '',
    title: '',
    outMpAppId: '',
    fixedImgFuncType: '',
    status: ACTIVITY_STATUS.effective,
    omSmsGroundImgList: []
  };
  imageSkipInfo: ImageSkipInfo = {
    groundImg: '',
    imgClick: '',
    link: '',
    linkType: '',
    outMpAppId: ''
  };

  get formTheme() {
    return this.activeInfo.registWinType ? this.activeInfo.registWinType.toLowerCase() : '';
  }

  @Watch('$route')
  public onRouteChanged() {
    this.getActiveDetail();
  }

  created() {
    this.isBaidu = decodeURIComponent(location.href).includes('bd_vid') || decodeURIComponent(location.href).includes('__BD_VID__') || decodeURIComponent(location.href).includes('{{BD_VID}}')
    this.getActiveDetail();
    this.invitationCode = getUrlParam('invitationCode');
    this.clickid = getUrlParam('clickid');
  }

  // 获取商品数据
  getActiveDetail() {
    const templateId = getUrlParam('id');

    if (!templateId) {
      return;
    }

    /* eslint-disable */
    const {aplus_queue} = window as any;

    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [{is_auto: false}]
    });
    /* eslint-enable */

    this.$http({
      url: `${merchantApi.getActiveDetail.url}/${templateId}`,
      method: merchantApi.getActiveDetail.method
    }).then((res: ServerResponse) => {
      this.activeInfo = res.data;
      document.title = this.activeInfo.title || '';

      this.imageSkipInfo = {
        groundImg: '',
        imgClick: res.data.fixedImgFuncType || '',
        link: res.data.link || '',
        linkType: res.data.linkType || '',
        outMpAppId: res.data.outMpAppId || ''
      };
    });
  }

  // linkType	跳转链接类型：IN/OUT/OUT_MP
  // outMpAppId	外部小程序APPID（OUT_MP时存在值，配合link使用）

  // 点击图片后跳转
  imageClick(item: ImageSkipInfo) {
    console.log(item,'link',this.clickid);
    let linkStr=item.link
    if(this.clickid){
      linkStr=linkStr+'%2526clickid%253D'+this.clickid
    }
    switch (item.imgClick) {
      case ACTIVITY_SKIP_TYPE.register:
        this.showRegisterBox = true;
        break;
      case ACTIVITY_SKIP_TYPE.link:
        if (item.linkType === ACTIVITY_LINK_TYPE.in) {
          this.$router.push({
            path: this.createImageSkipPath(item.linkType, linkStr)
          });
        } else if (item.linkType === ACTIVITY_LINK_TYPE.out) {
         
          window.location.href = this.createImageSkipPath(item.linkType, linkStr);
        } else {
          skipToMp(linkStr, item.outMpAppId);
        }
        break;
      default:
        return;
    }
  }

  // 生成图片跳转地址
  createImageSkipPath(linkType: string, link: string) {
    
    let skipPath = '';

    if (linkType === ACTIVITY_LINK_TYPE.in) { // 内部地址后台配置的是模板id, link字段的值是模板id
      skipPath = `/merchant/activity/common?id=${link}&invitationCode=${this.invitationCode}`;
    } else if(this.isBaidu) {
      skipPath = this.bdPath(link)
    } else {
      skipPath = link;
    }
console.log(skipPath,"skipPath");

    return skipPath;
  }

  // 注册成功回调
  registerSuccessCallBack() {
    this.showRegisterBox = false;
  }

  // 百度投放跳转链接处理
  bdPath(link: string) {
    return link + encodeURIComponent(encodeURIComponent(`&baiduLogidUrl=${decodeURIComponent(location.href)}`))
  }
}
